<template>
  <div>
    <b-navbar toggleable="lg" :sticky="true" class="border-bottom bg-light">
      <b-container fluid>
        <b-navbar-brand href="/">GalsenManager</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
<!--            <li class="nav-item">-->
<!--              <Link :href="route('orders.index')" class="nav-link">Формы</Link>-->
<!--            </li>-->
            <li class="nav-item" v-if="$page.props.can.invoices['view-any']">
              <Link :href="route('backend.proforma-invoices.index')" class="nav-link">КП</Link>
            </li>
            <li class="nav-item" v-if="$page.props.can.orders['view-any']">
              <Link :href="route('backend.orders.index')" class="nav-link">Заказы</Link>
            </li>
            <template v-if="$page.props.user.role === 'admin'">
              <li class="nav-item" v-if="$page.props.can.sets['view-any']">
                <Link :href="route('backend.sets.index')" class="nav-link">Комплекты</Link>
              </li>
              <li class="nav-item" v-if="$page.props.can.components['view-any']">
                <Link :href="route('backend.components.index')" class="nav-link">Компоненты</Link>
              </li>
              <li class="nav-item" v-if="$page.props.can.sections['view-any']">
                <Link :href="route('backend.sections.index')" class="nav-link">Направления и разделы</Link>
              </li>
              <li class="nav-item" v-if="$page.props.can.news['view-any']">
                <Link :href="route('backend.news.index')" class="nav-link">Новости</Link>
              </li>
            </template>
          </b-navbar-nav>

          <b-navbar-nav class="ml-0 ml-lg-auto" v-if="$page.props.user.role === 'admin'">
<!--            <li class="nav-item">-->
<!--              <Link :href="route('backend.orders.index')" class="nav-link">Секции</Link>-->
<!--            </li>-->
<!--            <li class="nav-item">-->
<!--              <Link :href="route('backend.orders.index')" class="nav-link">Страницы</Link>-->
<!--            </li>-->
<!--            <b-nav-item-dropdown text="Прайс" right>-->
<!--              <Link :href="route('backend.orders.index')" class="dropdown-item">Сгенерировать прайс</Link>-->
<!--              <Link :href="route('backend.orders.index')" class="dropdown-item">Загрузить каталог</Link>-->
<!--            </b-nav-item-dropdown>-->
          </b-navbar-nav>

          <b-navbar-nav class="ml-auto">
<!--            <b-nav-item-dropdown text="Система" right>-->
<!--              <Link :href="route('orders.index')" class="dropdown-item">Robots.txt</Link>-->
<!--              <Link :href="route('orders.index')" class="dropdown-item">Сбросить кэш</Link>-->
<!--            </b-nav-item-dropdown>-->

            <li class="nav-item">
              <Link :href="route('logout')" method="post" as="button" class="nav-link btn btn-link" title="Выход">
                <font-awesome-icon icon="sign-out-alt"/>
                {{ $page.props.user.name }}
              </Link>
            </li>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

    <main class="py-4">
      <b-container fluid>
        <flash-message></flash-message>
        <slot/>
      </b-container>
    </main>
  </div>
</template>

<script>

export default {
  props: {
    title: String
  },

  watch: {
    title: {
      immediate: true,
      handler (title) {
        document.title = title
      }
    }
  }
}
</script>
